import React from "react"
import { IngestionJob } from "../../api/ingestionJob"
import { AddPolicyStep } from "./add-policy-step"
import { ConfirmPolicyDataStep } from "./confirm-policy-data-step"

export const PolicyWorkflow = ({ workflowStep, job, next, back, cancel, store }:
    { workflowStep: number, job: IngestionJob, next, back, cancel, store }) => {
    return <>
        {workflowStep === 1 && <AddPolicyStep job={job} next={next} back={back} cancel={cancel} />}
        {workflowStep === 2 && <ConfirmPolicyDataStep jobId={job.id} back={back} cancel={cancel} store={store} />}
    </>
}